export type AvatarSize = "xs" | "sm" | "md" | "lg" | "xl";

export const sizes: Record<AvatarSize, number> = {
  xs: 24,
  sm: 36,
  md: 48,
  lg: 96,
  xl: 180,
};

const AVATAR_IMAGE_SIZE = 500;

export const getOptimizedInitials = (
  firstName?: string,
  lastName?: string,
): string => {
  if (firstName && lastName) {
    return (firstName[0] + lastName[0]).toUpperCase();
  }
  if (firstName && firstName.length > 1) {
    return firstName.slice(0, 2).toUpperCase();
  }
  if (lastName && lastName.length > 1) {
    return lastName.slice(0, 2).toUpperCase();
  }
  return (firstName?.[0] ?? lastName?.[0] ?? "?").toUpperCase();
};

export const getOptimizedPictureUrl = (
  picture?: string | null,
): string | null => {
  if (!picture) return null;
  return picture.replace(/s\d+-c/, `s${AVATAR_IMAGE_SIZE}-c`);
};

export const getAvatarFontSize = (size: AvatarSize) => {
  if (size === "xl") return "h2";
  if (size === "lg") return "h4";
  return "body2";
};
